import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { DB_POSTFIX, truncateWords } from "../../utils";

const Events = (props) => {
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return { day, month, year };
  }

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?sadb=" +
          DB_POSTFIX +
          "&type=event" +
          "&upcoming=1"
      )
      .then((res) => {
        if (res.data.status === "1") {
          setDataList(res.data.data);
        }
        setLoader(false);
      });
  };

  return (
    <div className="new-area">
      <div align="center" className="announcement-title">
        Events
      </div>

      <div className="scroll">
        {dataList.length > 0 ? (
          <>
            <marquee
              direction="up"
              scrollAmount="3"
              className="w-100"
              onMouseOver={(e) => e.target.stop()}
              onMouseOut={(e) => e.target.start()}
              style={{ height: "450px" }}
            >
              {dataList.map((item, index) => (
                <div key={index} className="row g-0 shadow-sm mb-3">
                  <div className="col-4">
                    <div className="year-box text-center">
                      {formatDate(item.active_from_date).year}
                    </div>
                    <div className="date-month text-center">
                      <div className="day">
                        {formatDate(item.active_from_date).day}
                      </div>
                      <div className="month text-center">
                        {formatDate(item.active_from_date).month}
                      </div>
                    </div>
                  </div>
                  <div className="col-8 bg-area">
                    <div className="right d-flex flex-column justify-content-center align-items-start">
                      <div className="text-start ms-2 text-capitalize fw-bold">
                        {item.title}
                      </div>
                      <div
                        className="content-event ms-2 text-capitalize mt-1"
                        style={{ fontSize: "14px" }}
                        dangerouslySetInnerHTML={{
                          __html: truncateWords(item?.content_html || "", 8),
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
            </marquee>

            <div className="footer-btn">
              <a href="/events">View All</a>
            </div>
          </>
        ) : (
          <div className="text-center py-3">No events found</div>
        )}
      </div>
    </div>
  );
};

export default Events;
